/******************************************************************************
  	Simple Ajax Pagination
 ******************************************************************************/
;(function($){
	'use strict';

	$( document ).ready( function() {

		var next_page = function( $this ) {
			var $button = $this.find( '.load-more > .paging-nav' ),
				$data = $this.find( '.ajax_data' ),

				query = $data.data( 'query' ),
				nonce = $data.data( 'nonce' ),
				start = $data.data( 'start' ),
				end = $data.data( 'end' ),
				layout = $data.data( 'layout' ),
				site = $data.data( 'site' ),
				url = $data.data( 'url' ),
				data = {
					'_icit_ajax': 'What did you hope to find?',
					'action': 'next_page',
					'query': query,
					'nonce': nonce,
					'start': start,
					'end': end,
					'layout': layout,
					'site': site
				},
				$target = $( layout );

			if ( !$button.hasClass( 'disabled' ) ) {
				$button.addClass( 'disabled' );
				$.post( url, data, function( d, st, xhr ) {
					$button.removeClass( 'disabled' );
					if ( d !== null && typeof( d ) === 'object' && d.start !== undefined ) {
						$data.data( 'start', d.start );
						$data.data( 'end', d.end );
						if ( d.html ) {
							$target.append( d.html );
						}
						if ( d.found <= d.end ) {
							$button.remove();
						}
					}
				}, 'json' );
			}
		};


		$( '.simple-ajax-pagination' ).each( function() {
			var $this = $( this );

			// Add the new button and remove the normal paging nav
			$this
				.append( '<div class="load-more nav-links"><a href="#" class="paging-nav button outline">More articles</a></div>' )
				.siblings( '.pagination-links' ).hide();

			// Add the Ajax call
			$this.find( '.load-more > .paging-nav' ).on( 'click', function( e ) {
				e.preventDefault();
				next_page( $this );
			});
		} );

	} );
}(jQuery));
